
<template>
  <div>
    <v-dialog
      v-model="problem_dialog"
      max-width="500px"
      transition="dialog-transition"
      scrollable
      persistent
    >
      <v-card v-if="problem_dialog" style="border-radius:12px">
        <v-card-title primary-title>
          <div class="title mb-0">Detalhe o motivo e valor do problema/retorno</div>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form ref='problemForm' lazy-validation>
            <v-text-field v-model="motive" :rules="ck_motive" v-mask="'##'" prepend-icon="mdi-information" label="Código do Motivo"></v-text-field>
            <v-text-field v-model="comment" prepend-icon="mdi-message-reply" label="Comentário"></v-text-field>
          </v-form>

        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-end">
          <f-btn @click="closeDialog()" cancel></f-btn>
          <f-btn @click="submitProblem()" save alt_text="Relatar problema"></f-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <dialog-loading v-if="loading"></dialog-loading>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import {CurrencyDirective} from 'vue-currency-input'
import validations from '@/mixins/validations'
import { mask } from'vue-the-mask'
import Api from '@/api/index';

export default {
  name: 'CheckProblemDialog',

  mixins: [
    validations
  ],
  directives: {
    currency: CurrencyDirective,
    mask,
  },
  props: {
    problem_dialog: {
      type: Boolean,
      default: false
    },
    check: {
      type: Object,
    }
  },
  data() {
    return {
      currency:{
        currency: null,
        locale: 'en-EN',
        autoDecimalMode: true,
        decimalLength: 2,
        distractionFree:false,
      },

      motive: null,
      comment: null,

      loading: false,
    }
  },
  methods: {
    closeDialog() {
      this.$emit('closeDialog')
    },
    submitProblem(){
      if (this.$refs.problemForm.validate()){
        let c = confirm('Deseja salvar os problemas com o cheque?')

        if (c) {
          this.returnCheck()
        }
      }
    },
    returnCheck(){
      const {id, check_number, value, place_id, solution} = this.check
      let returned_check_attributes = {
        value: Number(value),
        returned_by: this.current_user_employee_name,
        place_id,
        solution,
        comment: this.comment,
        motive: this.motive,
        number: check_number,
      }
      let obj = {
        id,
        returned: true,
        returned_due: this.motive,
        returned_check_attributes,
      }

      this.updateCheck(obj)
    },
    updateCheck(obj){
      let noti = {
        type: 'success',
        msg: 'Feito com sucesso'
      }
      this.loading = true
      Api.Check.update(obj).then(r=>r.data).then(r=> {
        this.$emit('doneReturned')
      }).catch(err=>{
        console.error({err});
        noti = {
          type: 'error',
          msg: `Erro: ${err}`
        }
      }).finally(()=>{
        this.loading = false
        this.addNotification(noti)
      })
    },

  },
}
</script>